
import axios from 'axios'

const DB = {
  // prefix: '/stream/srv.php?srv=',
  prefix: '/api/',
  request: (opts) => {
    const {
      url,
      method = 'get',
      params = {},
      data = {},
      headers = {},
      cache = false,
    } = opts

    if(!cache){
      params._v = Date.now()
    }

    return axios({
      method: method,
      url,
      params,
      data,
      headers
    }).then(res => {
      if(res.data.errno !== 0) {
        throw new Error(res.data)
        return res.data
      }
      return res.data
    })
  }
}

export default DB



// WEBPACK FOOTER //
// ./src/common/db.js